var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91634 4.95833H8.49967C9.14134 4.95833 9.66634 5.48333 9.66634 6.125V11.9583C9.66634 12.6 9.14134 13.125 8.49967 13.125H1.49967C0.858008 13.125 0.333008 12.6 0.333008 11.9583V6.125C0.333008 5.48333 0.858008 4.95833 1.49967 4.95833H2.08301V3.79167C2.08301 2.18167 3.38967 0.875 4.99967 0.875C6.60967 0.875 7.91634 2.18167 7.91634 3.79167V4.95833ZM4.99967 2.04167C4.03134 2.04167 3.24967 2.82333 3.24967 3.79167V4.95833H6.74967V3.79167C6.74967 2.82333 5.96801 2.04167 4.99967 2.04167ZM1.49967 11.9583V6.125H8.49967V11.9583H1.49967ZM6.16634 9.04167C6.16634 9.68333 5.64134 10.2083 4.99967 10.2083C4.35801 10.2083 3.83301 9.68333 3.83301 9.04167C3.83301 8.4 4.35801 7.875 4.99967 7.875C5.64134 7.875 6.16634 8.4 6.16634 9.04167Z",
    fill: "#8692A6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockGray);
export default __webpack_public_path__ + "static/media/lock-gray.8b8d8c895d290585e4fae6525497ced3.svg";
export { ForwardRef as ReactComponent };